import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ProblemSolution } from "./components/ProblemSolution";
import { FeaturesShowcase } from "./components/FeaturesShowcase";
import { AllFeatures } from "./components/AllFeatures";
import { WhyLogirent } from "./components/WhyLogirent";
import { Pricing } from "./components/Pricing";
import { LogitrakSection } from "./components/LogitrakSection";
import { Advantages } from "./components/Advantages";
import { Testimonials } from "./components/Testimonials";
import { HowItWorks } from "./components/HowItWorks";
import { FAQ } from "./components/FAQ";
import { CTA } from "./components/CTA";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ProblemSolution />
      <FeaturesShowcase />
      <AllFeatures />
      <WhyLogirent />
      <Pricing />
      <LogitrakSection />
      <Advantages />
      <Testimonials />
      <HowItWorks />
      <FAQ />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
